export const inputCls =
  "w-full rounded-md border border-lavender-700/15 bg-white px-4 py-3 text-sm text-stone-800 placeholder:text-stone-400 transition-colors focus:border-lavender-500 focus:outline-none focus:ring-2 focus:ring-lavender-500/30";

export function Field({ id, label, children, className = "" }) {
  return (
    <div className={className}>
      <label className="text-sm font-medium text-stone-600" htmlFor={id}>{label}</label>
      {children}
    </div>
  );
}

export function SectionTitle({ step, title, hint }) {
  return (
    <div className="flex items-baseline gap-3 border-b border-lavender-700/10 pb-3">
      <span className="font-serif text-2xl text-lavender-700">{step}</span>
      <div>
        <h3 className="font-serif text-xl text-stone-900">{title}</h3>
        {hint && <p className="text-xs text-stone-500">{hint}</p>}
      </div>
    </div>
  );
}
